<template>
	<popup title="Edit gateway" @close="$emit('close')">
		<template v-slot:content>
			<div class="gateway_edit_wrpr" style="position: relative;padding: 10px 6px 0;">

				<div class="form-group with_top_block">
					<span class="form_group_top_block">Gateway</span>
					<v-select v-model="userGateway.gateway_id"
					          :value="userGateway.gateway_id"
					          disabled
					          :clearable="false"
					          :searchable="false"
					          label="name"
					          :reduce="x => x.id"
					          :options="currentGroup.gateways"
					          append-to-body>
					</v-select>
				</div>
				<input-field class="margin-b-20" label="Gateway name" info="To help you identify your gateway"
				             v-model="userGateway.name">

				</input-field>

				<div v-if="currentGateway">

					<!-- stripe -->
					<fpay-stripe-settings v-if="isStripe" :currentGroup="currentGroup" :userGateway="userGateway"
					                      :userGatewayConfig="localConfig" @goBack="$emit('goBack')" />
					<fpay-mollie-settings v-else-if="isMollie" :currentGroup="currentGroup" :userGateway="userGateway"
					                      :userGatewayConfig="localConfig" @goBack="$emit('goBack')" />

					<div v-else>
						<div class="margin-t-15"
						     v-for="(gateItem, gateIndex) in currentGatewayConfig"
						     :key="'gate-config-'+gateIndex">

							<input-field v-if="gateItem.type === 'string'" class="margin-b-20"
							             :value="localConfig[gateItem.name]"
							             v-model="localConfig[gateItem.name]"
							             :label="gateItem.caption"  />

							<div class=" " v-else-if="gateItem.type === 'boolean'">
								<v-switch class="flex-none" :label="gateItem.caption" v-model="localConfig[gateItem.name]"
								          :value="localConfig[gateItem.name]" :description="gateItem.description"  />
							</div>

							<boolean_group v-else-if="gateItem.type==='boolean_group'" :config="localConfig" :item="gateItem" />

						</div>
					</div>
				</div>
			</div>
		</template>

		<template v-slot:actions>
			<v-button @click="$emit('goBack')" border >Back</v-button>
			<v-button @click="save" label="Save changes" :loading="creating" />
			<v-button @click="$emit('close')" border >Cancel</v-button>
		</template>
	</popup>

</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import Loading from "@/components/Loading";
import API from '@/api';
import FpayStripeSettings from "@/views/funnels/apps/funnel-apps/fpay/fpay-stripe-settings";
import VSwitch from "@/components/base/v-switch";
import Boolean_group from "@/views/funnels/apps/funnel-apps/fpay/types/boolean_group";
import FpayMollieSettings from "@/views/funnels/apps/funnel-apps/fpay/gateways/fpay-mollie-settings";


export default {
	name: "fpay-edit-user-gateway-popup",
	components: {FpayMollieSettings, Boolean_group, VSwitch, FpayStripeSettings, Loading, InputField, VButton, Popup},
	props: ['groups', 'currentGroup', 'userGateway'],
	mixins: [API],
	data: function () {
		return {
			creating: false,
			currentGroupId: 0,
			localConfig: {},
		}
	},
	computed: {
		isStripe() {
			return ['stripe','stripe-klarna','stripe-p24','stripe-eps','stripe-ideal','stripe-bancontact','stripe-sofort','stripe-sepa'].includes(this.currentGateway.key);
		},
		isMollie() {
			return ['mollie','mollie-ideal','mollie-bancontact'].includes(this.currentGateway.key);
		},
		currentGatewayConfig() {
			let g = this.currentGateway;
			if (!g) return {};
			return JSON.parse(g.config);
		},
		currentGateway() {
			let g = this.currentGroup.gateways.find(x => x.id===this.userGateway.gateway_id);
			return g;
		}
	},
	methods: {
		goBack() {
			this.$emit('goBack');
		},
		async save() {
			try {
		    this.creating = true;

		    let data = this.userGateway;
		    data.gateway_id = this.userGateway.gateway_id;
		    data.user_id = parseInt(this.$store.state.userInfo.id);
				data.config = JSON.stringify(this.localConfig)

		    let result = await this.patchUserGateway(data.id, data);
		    if (result.status === 200) {
			    // var item = result.data;
			    // this.currentGroup.user_gateways.push(item);
			    this.goBack();
					this.$info("","Gateway configuration updated successfully")
		    } else {
		    	throw result;
		    }
		  } catch (ex) {
				let msg = "Something went wrong! try again.";
				if (ex.data && ex.data.toLowerCase().indexOf('duplicate')>=0)
					msg = "A gateway with the same name already exists in your account.";
		    this.$error(ex, msg)
		    console.error("error:", ex)
		  } finally {
		    this.creating = false;
		  }
		}
	},
	mounted() {
		try {
			this.localConfig = JSON.parse(this.userGateway.config || '{}')
			if (typeof this.localConfig !== 'object') {
				console.error("invalid type", typeof this.localConfig, ".")
				this.localConfig = {}
			}
		} catch (e) {
			console.error(e)
			this.localConfig = {}
		}
	}
}
</script>

<style scoped>

</style>
